import { useState } from "react";
import { toast } from "sonner";
import api from "@/lib/api";

export default function Contact() {
  const [f, setF] = useState({ name: "", email: "", subject: "", message: "" });
  const [sent, setSent] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const submit = async (e) => {
    e.preventDefault();
    try { const { data } = await api.post("/contact", f); toast.success(data.message); setSent(true); }
    catch { toast.error("Could not submit. Please try again."); }
  };
  return (
    <div className="max-w-[720px] mx-auto px-4 sm:px-6 py-12">
      <div className="border-b-2 border-ink pb-3 mb-8">
        <div className="text-[11px] font-bold uppercase tracking-[0.2em] text-crimson">Get in touch</div>
        <h1 className="font-serif font-bold text-4xl sm:text-5xl text-ink mt-1">Contact</h1>
        <p className="text-ink2 mt-2">Story tips, corrections, and general enquiries are welcome.</p>
      </div>
      {sent ? (
        <div className="border border-hair p-8 bg-subtle text-center"><h3 className="font-serif text-2xl">Message received</h3><p className="text-ink2 mt-2 text-sm">Thank you — we will respond as soon as we can.</p></div>
      ) : (
      <form onSubmit={submit} className="space-y-4 border border-hair p-6 bg-surface" data-testid="contact-form">
        <label className="block"><span className="text-xs font-bold uppercase tracking-widest text-ink2 mb-1 block">Name</span><input required value={f.name} onChange={set("name")} data-testid="contact-name" className="tfd-input" /></label>
        <label className="block"><span className="text-xs font-bold uppercase tracking-widest text-ink2 mb-1 block">Email</span><input type="email" required value={f.email} onChange={set("email")} data-testid="contact-email" className="tfd-input" /></label>
        <label className="block"><span className="text-xs font-bold uppercase tracking-widest text-ink2 mb-1 block">Subject</span><input value={f.subject} onChange={set("subject")} data-testid="contact-subject" className="tfd-input" /></label>
        <label className="block"><span className="text-xs font-bold uppercase tracking-widest text-ink2 mb-1 block">Message</span><textarea rows={5} required value={f.message} onChange={set("message")} data-testid="contact-message" className="tfd-input" /></label>
        <button className="w-full bg-crimson hover:bg-crimsonhover text-white py-3 text-sm font-semibold uppercase tracking-wider" data-testid="contact-submit">Send Message</button>
      </form>)}
      <style>{`.tfd-input{width:100%;border:1px solid #E2DDD5;padding:0.65rem 0.8rem;font-size:0.9rem;outline:none;background:#fff}.tfd-input:focus{border-color:#901321}`}</style>
    </div>
  );
}
